import { useCallback } from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import Prebooking from "../types/Prebooking";

export default function useCreatePrebooking (languageId: number) {
    const client = useAPIClient();
    return useCallback(() => {
        return client.post<Prebooking>(`prebookings`, {
            'prebookingLanguage': languageId
        });
    }, [client])
}
